
import vueAuthInstance from '@/services/auth.js'
import ApiService from '@/common/api.service'
import Vue from 'vue'
import appConfig from '@/config'

export default {
  state: {
    uid: null,
    eid: window.localStorage.getItem('eid') || null,
    email: null,
    profile: {},
    isInternational: false,
    isAuthenticated: vueAuthInstance.isAuthenticated(),
    universe: {},
    ecosystemModules: {},
    isMoova: false
  },

  mutations: {
    isAuthenticated (state, payload) {
      state.isAuthenticated = payload.isAuthenticated
    },

    isInternational (state, payload) {
      state.isInternational = payload
    },

    async setProfile (state, payload) {
      state.profile = payload.profile

      const has3p = await Vue.http.get(appConfig.api.baseUrl + 'outsourcing-quotes', {params: {limit: 1}})
        .then(response => {
          return !!response.body.data[0]?.id
        })

      state.universe = {...state.universe, has3p}

      if (payload.profile) {
        var v = document.cookie.match('(^|;) ?countryForced=([^;]*)(;|$)')
        let cookieValue = v ? v[2] : null
        if (cookieValue !== 'true') {
          let country = payload.profile.company ? payload.profile.company.country_iso_code : payload.profile.country_iso_code
          document.cookie = 'country=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
          window.country = payload.profile.company ? payload.profile.company.country_iso_code : payload.profile.country_iso_code
          document.cookie = 'country=' + country + ';path=/; SameSite=' + process.env.COOKIE_SAME_SITE + '; ' + process.env.COOKIE_SECURE
        }
      }
    },

    setUid (state, uid) {
      state.uid = uid
    },

    setEmail (state, email) {
      state.email = email
    },

    setEid: (state, eid) => {
      window.localStorage.setItem('eid', eid)
      state.eid = eid
      if (eid === '1' || eid === 1) {
        state.isMoova = true
      }
    },

    setUniverse (state, payload) {
      const themeClass = payload && payload.theme ? payload.theme : 'moova'
      document.documentElement.className = themeClass
      document.getElementById('app').className = themeClass
      if (payload) {
        let universe
        if (window.countries && window.countries.length > 0 && !payload.merged) {
          let countryUniverseOverride = window.countries.findIndex(x => x.iso_code === window.$cookies.get('country')) !== -1 ? window.countries.find(x => x.iso_code === window.$cookies.get('country')).front_config.universe : {}
          if (countryUniverseOverride) {
            universe = {...payload, ...countryUniverseOverride, ...{merged: true}}
          }
        }
        state.universe = universe || payload
      }
    },

    setEcosystemModules (state, payload) {
      if (payload) {
        let universe
        if (window.countries && window.countries.length > 0 && !payload.merged) {
          let countryUniverseOverride = window.countries.findIndex(x => x.iso_code === window.$cookies.get('country')) !== -1 ? window.countries.find(x => x.iso_code === window.$cookies.get('country')).front_config.ecosystemModules : {}
          if (countryUniverseOverride) {
            universe = {...payload, ...countryUniverseOverride, ...{merged: true}}
          }
        }
        state.ecosystemModules = universe || payload
      }
    }
  },
  getters: {
    uid: state => {
      return state.uid
    },
    eid: state => {
      return state.eid
    },
    profile: state => {
      return state.profile
    },
    email: state => {
      return state.email
    },
    isInternational: state => {
      return state.isInternational
    },
    isMoova: state => {
      return state.isMoova
    },
    universe: state => {
      return state.universe
    },
    ecosystemModules: state => {
      return state.ecosystemModules
    }
  },

  actions: {
    login (context, payload) {
      payload = payload || {}
      return vueAuthInstance.login(payload.user, payload.requestOptions)
        .then(response => {
          context.commit('isAuthenticated', {
            isAuthenticated: vueAuthInstance.isAuthenticated()
          })
          const uid = vueAuthInstance.getPayload() ? vueAuthInstance.getPayload()['sub'] : null
          context.commit('setUid', uid)
          if (response.body.ecosystem_id) {
            context.commit('setEid', response.body.ecosystem_id)
            ApiService.query('countries')
              .then(response => {
                window.countries = response.body.data
              })
          }
        })
    },

    register (context, payload) {
      payload = payload || {}
      return vueAuthInstance.register(payload.user, payload.requestOptions).then(function () {
        context.commit('isAuthenticated', {
          isAuthenticated: vueAuthInstance.isAuthenticated()
        })
      })
    },

    logout (context, payload) {
      payload = payload || {}
      payload.requestOptions = vueAuthInstance.options
      return vueAuthInstance.logout(payload.requestOptions).then(function () {
        context.commit('setUid', null)
        context.commit('setEmail', null)
        context.commit('setProfile', {})
        context.commit('isAuthenticated', {
          isAuthenticated: vueAuthInstance.isAuthenticated()
        })
      })
    },

    authenticate (context, payload) {
      payload = payload || {}
      return vueAuthInstance.authenticate(payload.provider, payload.userData, payload.requestOptions).then(function () {
        context.commit('isAuthenticated', {
          isAuthenticated: vueAuthInstance.isAuthenticated()
        })
      }).catch((err) => {
        console.log(err)
      })
    },

    setEid (context, eid) {
      context.commit('setEid', eid)
    },

    setUniverse (context, payload) {
      context.commit('setUniverse', payload)
    },

    setEcosystemModules (context, payload) {
      context.commit('setEcosystemModules', payload)
    }
  }
}
